import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import FileUpload from '../../../../component/FileUpload';
import classes from './style.module.scss';

const IndividualQR = (props) => {
    const { fileName, setFileName, isFileUploading, setIsFileUploading, formMethods, errors, required = true, files, setFiles } = props


    return (
        <div>
            <div className={`mt-5`}>
                <div className={classes.titleHeader}>Upload Product detail sheet</div>
                <FileUpload
                    name="uploadResource"
                    className={`p-8 py-12 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadResource}
                    messages={{
                        required: "File is required",
                    }}
                    maxSize={20971520}
                    maxLable= "20MB"
                    required={required}
                    label="Upload File"
                    acceptFiles=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    fileNames={fileName}
                    setFileName={setFileName}
                    uploadedFiles={files}
                    setUploadedFiles={setFiles}
                    isFileUploading={isFileUploading}
                    placeholder="Upload File (Max: 20 MB)"
                    alignment={'center'}
                />
            </div>
        </div>
    )
}

export default IndividualQR